// Add this to src/main.js to communicate iframe height to parent
import App from './app.svelte';

// For local development
const app = new App({
  target: document.getElementById('app') || document.body
});

// Resize observer for iframe communication
function setupResizeObserver() {
  if (window.self !== window.top) {
    window.addEventListener('DOMContentLoaded', () => {
      const container = document.querySelector('.app-container');
      if (!container) return;

      const resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          // Get content height plus some padding
          const height = entry.target.scrollHeight + 20;
          // Include viewport width info
          window.parent.postMessage({ 
            type: 'resize', 
            height: height,
            width: document.documentElement.clientWidth
          }, '*');
        }
      });

      resizeObserver.observe(container);
      
      // Observe all dynamic content
      document.querySelectorAll('.question-wrapper, .question-content').forEach(el => {
        resizeObserver.observe(el);
      });
      
      // Also respond to resize events
      window.addEventListener('resize', () => {
        window.parent.postMessage({ 
          type: 'resize', 
          height: container.scrollHeight + 20,
          width: document.documentElement.clientWidth
        }, '*');
      });
    });
  }
}

// For embedding as a widget (when loaded from another site)
export function init(targetSelector = '#cavs-survey-widget', options = {}) {
  const target = document.querySelector(targetSelector);
  
  if (!target) {
    console.error(`Target element "${targetSelector}" not found.`);
    return;
  }
  
  // Set embedded attribute on root element for CSS targeting
  document.documentElement.setAttribute('data-embedded', 'true');
  
  setupResizeObserver();
  
  // Apply any custom options passed from the parent
  if (options.theme) {
    document.documentElement.setAttribute('data-theme', options.theme);
  }
  
  // Add styles to make embedding seamless
  const style = document.createElement('style');
  style.textContent = `
    body, html {
      background: transparent !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
    }
  `;
  document.head.appendChild(style);
  
  return new App({ 
    target,
    props: {
      embedded: true,
      embedOptions: {
        ...options,
        transparent: true
      }
    }
  });
}

// Make the init function available globally
if (typeof window !== 'undefined') {
  window.initCavsSurvey = init;
  setupResizeObserver();
}

export default app;